module.exports = "<div class=\"input-group\">\n  <input type=\"text\" class=\"form-control\" ng-model=\"caddress\" placeholder=\"Search...\" id=\"search1\"\n         autocomplete=\"on\">\n  <span class=\"input-group-btn search\">\n        <button type=\"submit\" class=\"btn btn-default\"><i class=\"fa fa-search fa-lg\"></i></button>\n  </span>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./client/components/auto-console/auto-console.html
// module id = YL2n
// module chunks = 1 2